var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { StyledIndent } from './Indent.styled';
import { buildDataAttr, DATA_TEST } from '../../typings/data';

const getIndents = str => {
  var _a;

  return str !== undefined && ((_a = String(str)) === null || _a === void 0 ? void 0 : _a.split(' ').map(ind => !!parseInt(ind) ? `${ind}px` : ind).join(' '));
};

export const defaultProps = {
  [DATA_TEST]: 'indent',
  display: 'block'
};
export const Indent = _a => {
  var {
    display = defaultProps.display,
    padding,
    margin,
    tagName,
    children
  } = _a,
      otherProps = __rest(_a, ["display", "padding", "margin", "tagName", "children"]);

  const dataAttr = buildDataAttr(otherProps, defaultProps);
  return React.createElement(StyledIndent, Object.assign({
    display: display,
    padding: getIndents(padding),
    margin: getIndents(margin),
    as: tagName
  }, dataAttr), children);
};